import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { setShowPrintQrCodeModal } from "../redux-state/features/inventory/inventorySlice";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import urls from "../urls";
import Select from "react-select";
function PrintQrCodeModal() {
  const [options, setOptions] = useState([]);
  const [href, setHref] = useState("");
  const dispatch = useDispatch();
  const faculty_id = useSelector((state) => state.userState.faculty_id);
  const show = useSelector(
    (state) => state.inventoryState.showPrintQrCodeModal
  );
  const printType = useSelector((state) => state.inventoryState.printType);

  useEffect(() => {
    axios
      .get(urls.getUsedPlacesData, {
        params: {
          faculty_id,
        },
      })
      .then((res) => {
        const { results } = res.data;
        if (Array.isArray(results)) {
          const options = results.map((obj) => ({
            label: obj.place_name,
            value: obj.id,
          }));
          setOptions(options);
          console.log(options);
        }
      });
  }, []);

  const handleClose = () => dispatch(setShowPrintQrCodeModal(false));
  const handleChange = (option) => {
    const url =
      printType === "QrCode"
        ? urls.printMultipleInvQrCode
        : urls.printInventorySheet;
    const href = `${url}/${option.value}`;
    setHref(href);
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {printType === "QrCode"
              ? "طباعــة رمز الاستجابة السريعة QR code"
              : "طباعة ورقة الجرد"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select
            options={options}
            placeholder={"إختر مكان الاستغلال "}
            isSearchable
            isRtl
            onChange={handleChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            إلغاء
          </Button>
          <a
            className="btn btn-primary"
            href={href}
            target="_blank"
            onClick={(e) => !href && e.preventDefault()}
          >
            طباعــة
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PrintQrCodeModal;
